import { totalPagesFromCount } from "../../../shared/ui/Pagination/paginationModel";

/**
 * Strict positive safe-integer page query parsing for Deal list pagination.
 * Invalid values default to page 1 (no permissive parseInt partial matches).
 */
export const DEAL_LIST_PAGE_SIZE = 20;

export const parsePageParam = (raw) => {
  if (raw == null || raw === "") return 1;
  const text = String(raw);
  if (!/^[1-9]\d*$/.test(text)) return 1;
  const numeric = Number(text);
  if (!Number.isSafeInteger(numeric) || numeric <= 0) return 1;
  return numeric;
};

export const totalDealListPages = (count, pageSize = DEAL_LIST_PAGE_SIZE) =>
  totalPagesFromCount(count, pageSize);
